module.exports = "https://r.nearpod.com/assets/media/image/desmos-6ce4dc28c32dab14ff98a498c6d254cd.svg";